<template>
  <div class="post-wall-card-bottom row">
    <q-btn-group spread>
      <q-btn :disabled="isLogin" label="點讚" :class="{ 'have-like': postCardBottomData.LikeIt === 1 }" :icon="likeIcon" @click="clickLike()" />
      <q-btn :disabled="isLogin" label="留言" class="reply-btn" icon="fal fa-comment-dots" @click="openDialog()" />
      <!-- 已是分享他人文章的貼文不能再被分享 (檢查 0:沒有分享貼文 1:友圈內分享貼文 2:透過 API分享的貼文) &&  只在撈取所有貼文的貼文牆顯示分享(自己主頁或他人主頁不會出現分享按鈕)-->
      <q-btn
        :disabled="isLogin"
        v-if="(postCardBottomData.HasSharePost === 0 && this.$route.name === 'PostWall') || this.$route.name === 'Home'"
        label="分享"
        class="share-btn"
        icon="fal fa-share-alt"
        @click="goSharePost()"
      />
    </q-btn-group>
    <PostReplyDialog :replyData="replyData" @changeDisplay="changeDisplay"></PostReplyDialog>
  </div>
</template>

<script>
import PostReplyDialog from '@/components/PostWall/PostReplyDialog';
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
  name: 'PostWallCardBottom',
  props: ['postCardBottomData'],
  data() {
    return {
      dialog: false
    };
  },
  components: {
    PostReplyDialog
  },
  computed: {
    ...mapState(['isLogin', 'token']),
    // 判斷自己有沒有按這篇文讚
    likeIcon() {
      if (this.postCardBottomData.LikeIt === 1) {
        return 'fas fa-thumbs-up';
      }
      return 'fal fa-thumbs-up';
    },
    // 留言的 dialog 頁面需要的資料
    replyData() {
      return {
        dialogDisplay: this.dialog,
        postId: this.postCardBottomData.PostId,
        likeCount: this.postCardBottomData.LikeCount
      };
    }
  },
  methods: {
    ...mapActions('PostWallModule', ['clickApiLike']),
    ...mapMutations('PostWallModule', ['UPDATE_POST_LIKE_STATUS']),
    ...mapMutations('OnePostModule', ['UPDATE_ONEPOST_LIKE_STATUS']),
    // 點讚
    clickLike() {
      let likeData = {
        targetId: this.postCardBottomData.TargetId,
        postId: this.postCardBottomData.PostId,
        flag: this.postCardBottomData.LikeIt === 0 ? 1 : 0
      };
      this.clickApiLike(likeData);
      // 更新前端看到的 state 資料
      if (this.$route.name === 'OnePost') {
        this.UPDATE_ONEPOST_LIKE_STATUS(this.postCardBottomData.LikeIt === 0 ? 1 : 0);
      } else {
        // 在貼文牆時
        this.UPDATE_POST_LIKE_STATUS(likeData);
      }
    },
    // PostReply 此子 component 用來關閉父 component 的 dialog
    changeDisplay(childValue) {
      this.dialog = childValue;
    },
    // 跳到分享貼文
    goSharePost() {
      this.$router.push({ name: 'SharePost', params: { postId: this.postCardBottomData.PostId } });
    },
    // 開啟 dialog
    openDialog() {
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.post-wall-card-bottom {
  text-align: center;

  .q-btn-group {
    width: 100%;
    box-shadow: none;
    color: $LaleTitleBlack;

    .q-btn-item {
      padding: 10px 0;
    }
  }
}

.have-like {
  color: $LalePrimary;
}
</style>
<style lang="scss">
.post-wall-card-bottom {
  .q-btn .q-icon,
  .q-btn .q-spinner {
    font-size: 1em !important;
  }
}
</style>
